import React from "react"

import { TResolvedTextMedia } from "@/lib/kontent/components/getTextMedia"

import { ImageOverlapText } from "./ImageOverlapText"

type TImageOverlapTextResolverProps = {
  resolvedData: TResolvedTextMedia
  isInArticle?: boolean
}

const ImageOverlapTextResolver = ({
  resolvedData,
  isInArticle = false,
}: TImageOverlapTextResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    body: resolvedData.text,
    reverse: resolvedData.imagePosition === "Right",
    tagLabel: resolvedData.tag,
    icon: resolvedData.icon,
    // isBackgroundLight: resolvedData.textBackground === "Light",
    image: resolvedData.image
      ? {
          src: resolvedData.image.url,
          alt: resolvedData.image.description,
          variant: "default",
          width: resolvedData.image.width,
          height: resolvedData.image.height,
        }
      : null,
    isInArticle: isInArticle,
  }

  return <ImageOverlapText {...kontentData} />
}

export { ImageOverlapTextResolver, type TImageOverlapTextResolverProps }
